import { OnboardingSection } from "./types"

export const onboardingSections: OnboardingSection[] = [
  {
    id: "prissattning",
    titleKey: "alfred.lib.onboarding.sections.pricing",
    ownerOnly: true,
    videos: [
      {
        slug: "1-1-intro",
        titleKey: "alfred.lib.onboarding.videos.pricingIntro",
        youtubeId: "7Zi3CESmog0",
      },
      {
        slug: "1-2-personal",
        titleKey: "alfred.lib.onboarding.videos.staff",
        youtubeId: "lodJN79SLZ0",
      },
      {
        slug: "1-3-prislista",
        titleKey: "alfred.lib.onboarding.videos.priceList",
        youtubeId: "oZ81ndilC5o",
      },
      {
        slug: "1-4-prislista-fordjupning",
        titleKey: "alfred.lib.onboarding.videos.priceListInDepth",
        youtubeId: "DlFxxim3aNU",
      },
      {
        slug: "1-5-avgifter-intro",
        titleKey: "alfred.lib.onboarding.videos.feesIntro",
        youtubeId: "hnzGKKy-sCM",
      },
      {
        slug: "1-6-avgifter-forbrukningsavgift",
        titleKey: "alfred.lib.onboarding.videos.feesConsumables",
        youtubeId: "paX8VOFtq1Q",
      },
      {
        slug: "1-7-avgifter-elcykeltillagg",
        titleKey: "alfred.lib.onboarding.videos.feesEbikeSurcharge",
        youtubeId: "y89e1iyBuE8",
      },
      {
        slug: "1-8-avgifter-miljoavgift",
        titleKey: "alfred.lib.onboarding.videos.feesEnvironmental",
        youtubeId: "gLtc7EgaQFM",
      },
      {
        slug: "1-9-avgifter-ladcykeltillagg",
        titleKey: "alfred.lib.onboarding.videos.feesCargoBikeSurcharge",
        youtubeId: "PlLl090-mLI",
      },
      {
        slug: "1-10-avgifter-akutserviceavgift",
        titleKey: "alfred.lib.onboarding.videos.feesUrgentService",
        youtubeId: "uuB4k1p6bd8",
      },
      {
        slug: "1-11-servicepaket-intro",
        titleKey: "alfred.lib.onboarding.videos.servicePackagesIntro",
        youtubeId: "MgGE8XAfgj0",
      },
      {
        slug: "1-12-servicepaket-gratis",
        titleKey: "alfred.lib.onboarding.videos.servicePackagesFree",
        youtubeId: "pnMlAmbW4dU",
      },
      {
        slug: "1-13-servicepaket-storre",
        titleKey: "alfred.lib.onboarding.videos.servicePackagesLarger",
        youtubeId: "cojXoHydXTk",
      },
      {
        slug: "1-14-tvattar",
        titleKey: "alfred.lib.onboarding.videos.washes",
        youtubeId: "Qzu3gimjqGM",
      },
      {
        slug: "1-15-damparservice",
        titleKey: "alfred.lib.onboarding.videos.suspensionService",
        youtubeId: "GIEYNnOBXtA",
      },
    ],
  },
  {
    id: "butiksinstallningar",
    titleKey: "alfred.lib.onboarding.sections.storeSettings",
    ownerOnly: true,
    videos: [
      {
        slug: "2-1-intro",
        titleKey: "alfred.lib.onboarding.videos.storeSettingsIntro",
        youtubeId: "06GvohtTbI8",
      },
      {
        slug: "2-2-profil",
        titleKey: "alfred.lib.onboarding.videos.profile",
        youtubeId: "VxmC4N44Q-k",
      },
      {
        slug: "2-3-bokningsinstallningar-platser",
        titleKey: "alfred.lib.onboarding.videos.bookingSettingsSlots",
        youtubeId: "TnJFj3R7pQQ",
      },
      {
        slug: "2-4-bokningsinstallningar-ledtider",
        titleKey: "alfred.lib.onboarding.videos.bookingSettingsLeadTimes",
        youtubeId: "gqWEeHKx6uA",
      },
      {
        slug: "2-5-kommunikation-intro",
        titleKey: "alfred.lib.onboarding.videos.communicationIntro",
        youtubeId: "AcJtBuRCmlc",
      },
      {
        slug: "2-6-kommunikation-notiser",
        titleKey: "alfred.lib.onboarding.videos.communicationNotifications",
        youtubeId: "ITxcWDzk-RE",
      },
      {
        slug: "2-7-kommunikation-meddelanden",
        titleKey: "alfred.lib.onboarding.videos.communicationMessages",
        youtubeId: "ZAbhvoyH1vM",
      },
      {
        slug: "2-8-vad-ni-erbjuder",
        titleKey: "alfred.lib.onboarding.videos.whatYouOffer",
        youtubeId: "mRCk9VWJb6g",
      },
      {
        slug: "2-9-oppettider",
        titleKey: "alfred.lib.onboarding.videos.openingHours",
        youtubeId: "OV9YznYrs2c",
      },
      {
        slug: "2-10-konton",
        titleKey: "alfred.lib.onboarding.videos.accounts",
        youtubeId: "QKV5gM7P0F4",
      },
    ],
  },
  {
    id: "mottagningen",
    titleKey: "alfred.lib.onboarding.sections.reception",
    videos: [
      {
        slug: "3-1-bokat-jobb-snabb",
        titleKey: "alfred.lib.onboarding.videos.bookedJobQuick",
        youtubeId: "KRijlD4oc_g",
      },
      {
        slug: "3-2-bokat-jobb-ordentlig",
        titleKey: "alfred.lib.onboarding.videos.bookedJobThorough",
        youtubeId: "p__7jzqHbpc",
      },
      {
        slug: "3-3-dropin-snabb",
        titleKey: "alfred.lib.onboarding.videos.dropInQuick",
        youtubeId: "AiGmufOP9fs",
      },
      {
        slug: "3-4-dropin-ordentlig",
        titleKey: "alfred.lib.onboarding.videos.dropInThorough",
        youtubeId: "3jTH-z_7DqY",
      },
      {
        slug: "3-5-dropin-med-incheckning",
        titleKey: "alfred.lib.onboarding.videos.dropInWithCheckIn",
        youtubeId: "lkvcinIgKfY",
      },
      {
        slug: "3-6-avslutande-ord",
        titleKey: "alfred.lib.onboarding.videos.receptionClosingWords",
        youtubeId: "sxIhF42Oa-8",
      },
    ],
  },
  {
    id: "besiktningen",
    titleKey: "alfred.lib.onboarding.sections.inspection",
    videos: [
      {
        slug: "4-1-intro",
        titleKey: "alfred.lib.onboarding.videos.inspectionIntro",
        youtubeId: "s9FlYaWC-CA",
      },
      {
        slug: "4-2-starta-besiktning",
        titleKey: "alfred.lib.onboarding.videos.startInspection",
        youtubeId: "r9u_9J6gdqY",
      },
      {
        slug: "4-3-forsta-steg",
        titleKey: "alfred.lib.onboarding.videos.firstStep",
        youtubeId: "fBZcfhrmswE",
      },
      {
        slug: "4-4-andra-steg-intro",
        titleKey: "alfred.lib.onboarding.videos.secondStepIntro",
        youtubeId: "ohMV5q4qeIc",
      },
      {
        slug: "4-5-andra-steg-genomgang",
        titleKey: "alfred.lib.onboarding.videos.secondStepReview",
        youtubeId: "T2t2D64GXRg",
      },
      {
        slug: "4-6-andra-steg-produktbestallning",
        titleKey: "alfred.lib.onboarding.videos.secondStepProductOrder",
        youtubeId: "9qS_A35kJck",
      },
      {
        slug: "4-7-andra-steg-produktalternativ",
        titleKey: "alfred.lib.onboarding.videos.secondStepProductAlternatives",
        youtubeId: "V_oRvQsD34M",
      },
      {
        slug: "4-8-andra-steg-rabatter",
        titleKey: "alfred.lib.onboarding.videos.secondStepDiscounts",
        youtubeId: "GpY8evvpr8w",
      },
      {
        slug: "4-9-andra-steg-spara-utkast",
        titleKey: "alfred.lib.onboarding.videos.secondStepSaveDraft",
        youtubeId: "ksZ460kQhUY",
      },
      {
        slug: "4-10-tredje-steg-beroenden",
        titleKey: "alfred.lib.onboarding.videos.thirdStepDependencies",
        youtubeId: "R8kM4wW0j18",
      },
      {
        slug: "4-11-tredje-steg-algoritmen",
        titleKey: "alfred.lib.onboarding.videos.thirdStepAlgorithm",
        youtubeId: "pynP4N7xAxg",
      },
      {
        slug: "4-12-tredje-steg-skicka",
        titleKey: "alfred.lib.onboarding.videos.thirdStepSend",
        youtubeId: "SFOHxLKu9D0",
      },
      {
        slug: "4-13-aterkalla-serviceforslag",
        titleKey: "alfred.lib.onboarding.videos.withdrawServiceProposal",
        youtubeId: "pd5Xx4tmwNQ",
      },
    ],
  },
]
